export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'fltgrdCAPaket';
export const NAME = 'Capaket';

export const ND = 'Nd';
export const PP = 'Pp';

export const DEPENDENT_TABLES = <const>[
	ND,
	PP,
];
